import React from 'react';
import * as S from '@/components/Ad/MainInfo/MainInfo.styles';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { formatNumber } from '@/utils/helpers';
import { useAdDetails } from '@/views/Ads/useAdDetails';
import { Divider } from '@/components/UI/Divider/Divider.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';
import { useServerDataContext } from '@/contexts';

export const MainInfo = () => {
  const { initialAdDetails } = useServerDataContext();
  const { adDetails } = useAdDetails();
  const adData = adDetails ?? initialAdDetails;
  const { price, title } = adData ?? {};

  function getPrice() {
    if (price === undefined) {
      return (
        <SkeletonLoader
          dataTestId="ad-price-skeleton-loader"
          borderRadius={7}
          width="170px"
          height="28.8px"
        />
      );
    }

    if (price === null || price === 0) {
      return null;
    }

    return (
      <Typography.Numbers $variant="1" data-testid={AdPageTestIds.price}>
        {formatNumber(price, 2, true)} AZN
      </Typography.Numbers>
    );
  }

  return (
    <>
      <S.MainInfoBox>
        {getPrice()}
        {title ? (
          <Typography.Header
            as="h1"
            data-testid={AdPageTestIds.title}
            $variant="1"
          >
            {title}
          </Typography.Header>
        ) : (
          <SkeletonLoader
            dataTestId="ad-title-skeleton-loader"
            borderRadius={7}
            height="24px"
          />
        )}
      </S.MainInfoBox>
      <Divider $isSmall />
    </>
  );
};
